import { Link } from "react-router-dom";
import { ShieldCheck, BadgeCheck, RotateCcw, Star, ArrowRight } from "lucide-react";

const PAYMENT_METHODS = [
  { key: "wave", label: "Wave", bg: "#1DC4FF", fg: "#ffffff", initials: "W" },
  { key: "orange-money", label: "Orange Money", bg: "#FF6600", fg: "#ffffff", initials: "OM" },
  { key: "mtn-momo", label: "MTN MoMo", bg: "#FFCC00", fg: "#1a1a1a", initials: "MTN" },
  { key: "moov-money", label: "Moov Money", bg: "#0060AE", fg: "#ffffff", initials: "MV" },
  { key: "cinetpay", label: "CinetPay", bg: "#0e9f6e", fg: "#ffffff", initials: "CP" },
];

const SERVICES = [
  { icon: RotateCcw, text: "Remboursement en cas de probleme" },
  { icon: ShieldCheck, text: "Paiement securise jusqu'a la reception" },
  { icon: Star, text: "Avis verifies et vendeurs identifies" },
  { icon: BadgeCheck, text: "Protection acheteur sur chaque transaction" },
];

export default function TrustBanner() {
  return (
    <div className="relative rounded-3xl border-2 border-emerald-200 bg-gradient-to-br from-emerald-50/80 to-white p-5 md:p-6 overflow-hidden" data-testid="trust-banner">
      {/* Billet FCFA — coin haut droit */}
      <div
        className="absolute top-4 right-4 w-[74px] h-[42px] rounded-md rotate-[8deg] shadow-md grid place-items-center select-none"
        style={{ background: "linear-gradient(135deg,#b7e4c7,#74c69d)", border: "1.5px solid #2d6a4f" }}
        aria-hidden="true"
        data-testid="fcfa-bill"
      >
        <div className="absolute inset-1 rounded-[4px] border border-dashed border-emerald-900/30" />
        <span className="font-extrabold text-emerald-950 text-[13px] tracking-wider">FCFA</span>
        <span className="absolute top-0.5 left-1.5 text-[7px] font-bold text-emerald-900/70">1000</span>
        <span className="absolute bottom-0.5 right-1.5 text-[7px] font-bold text-emerald-900/70">1000</span>
      </div>

      <div className="flex items-start gap-3 pr-20">
        <div className="w-11 h-11 rounded-2xl bg-emerald-600 text-white grid place-items-center shrink-0 shadow-md">
          <ShieldCheck size={22} />
        </div>
        <div>
          <h3 className="font-bold text-[15px] md:text-base text-emerald-900 leading-snug">
            Avec la Transaction securisee, achetez en toute confiance !
          </h3>
          <p className="text-xs text-[var(--ink-soft)] mt-0.5">
            En payant en ligne sur Fodindin, vous accedez automatiquement a tous nos services :
          </p>
        </div>
      </div>

      <ul className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1.5">
        {SERVICES.map((s) => (
          <li key={s.text} className="flex items-center gap-2 text-[13px] text-[var(--ink)]">
            <s.icon size={14} className="text-emerald-600 shrink-0" />
            {s.text}
          </li>
        ))}
      </ul>

      <div className="mt-4 flex flex-wrap items-center gap-2" data-testid="payment-methods">
        {PAYMENT_METHODS.map((p) => (
          <span
            key={p.key}
            className="inline-flex items-center gap-1.5 bg-white border border-[var(--line)] rounded-full pl-1 pr-2.5 py-1 shadow-sm"
            data-testid={`payment-${p.key}`}
          >
            <span
              className="w-6 h-6 rounded-full grid place-items-center text-[8px] font-extrabold"
              style={{ background: p.bg, color: p.fg }}
            >
              {p.initials}
            </span>
            <span className="text-[11px] font-bold text-[var(--ink)]">{p.label}</span>
          </span>
        ))}
      </div>

      <div className="mt-3 flex items-center justify-between flex-wrap gap-2">
        <p className="text-[10px] italic text-[var(--ink-soft)]">
          Paiements traites via CinetPay (HTTPS, Mobile Money). Ne payez jamais hors de la plateforme.
        </p>
        <Link to="/faq-paiements" className="inline-flex items-center gap-1 text-xs font-bold text-emerald-700 hover:underline" data-testid="trust-learn-more">
          En savoir plus <ArrowRight size={12} />
        </Link>
      </div>
    </div>
  );
}
